<div class="maintenance-container">
  <img src="../../assets/img/server-maintenance-2355.png" />
  <h1>Lineup is currently down for maintenance.</h1>
  We expect to be back in a couple of minutes. Thanks for your patience.
</div>
